import { render, staticRenderFns } from "./PerCoordinator.vue?vue&type=template&id=b488610e&"
import script from "./PerCoordinator.vue?vue&type=script&lang=js&"
export * from "./PerCoordinator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports